import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/ClubhouseWoods.css";

import {
  Activity,
  Baby,
  BedDouble,
  CircleDot,
  Dumbbell,
  Flower2,
  Footprints,
  Map,
  Music,
  ShieldCheck,
  Sparkles,
  Target,
  Tent,
  Trees,
  Users,
  WavesLadder,
  Wifi,
} from "lucide-react";

import clubhouseHero from "../../assets/woods-images/clubhouse-woods.avif";

const indoorAmenities = [
  { label: "Banquet hall", icon: Users },
  { label: "Gym & indoor sports", icon: Dumbbell },
  { label: "High-speed Wi-Fi in social spaces", icon: Wifi },
  { label: "24-hour reception & monitoring", icon: ShieldCheck },
  { label: "Aerobics & yoga studio", icon: Activity },
  { label: "Terrace garden", icon: Flower2 },
  { label: "Squash court", icon: CircleDot },
  { label: "Spa & salon", icon: Sparkles },
  { label: "Guest bedrooms", icon: BedDouble },
];

const outdoorAmenities = [
  { label: "Swimming pool", icon: WavesLadder },
  { label: "Central park with open greens", icon: Trees },
  { label: "Outdoor party area", icon: Music },
  { label: "Children's play area", icon: Baby },
  { label: "Paved garden pathways", icon: Map },
  { label: "Gazebos", icon: Tent },
  { label: "Tennis court", icon: CircleDot },
  { label: "Basketball court", icon: Target },
  { label: "Jogging track", icon: Footprints },
];

export default function Clubhouse() {
  return (
    <section className="woods-clubhouse-section" id="woods-clubhouse">
      <div className="woods-clubhouse-hero">
        <img
          src={clubhouseHero}
          alt="Woods clubhouse"
          className="woods-clubhouse-hero-img"
          loading="lazy"
        />
      </div>

      <div className="woods-clubhouse-amenities">
        <div className="container">
          <div className="woods-clubhouse-header">
            <p className="woods-clubhouse-kicker">Clubhouse Amenities</p>
            <h2 className="woods-clubhouse-title">Indoor & Outdoor Experiences</h2>
          </div>

          <div className="row g-4">
            <div className="col-lg-6">
              <div className="woods-amenities-card">
                <div className="woods-amenities-heading">
                  <h3>Indoor amenities</h3>
                  <span className="woods-amenities-line" aria-hidden="true"></span>
                </div>
                <ul className="woods-amenities-grid">
                  {indoorAmenities.map((item) => {
                    const Icon = item.icon;
                    return (
                      <li className="woods-amenity-item" key={item.label}>
                        <span className="woods-amenity-box" aria-hidden="true">
                          <Icon size={13} />
                        </span>
                        <span className="woods-amenity-text">{item.label}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="woods-amenities-card">
                <div className="woods-amenities-heading">
                  <h3>Outdoor amenities</h3>
                  <span className="woods-amenities-line" aria-hidden="true"></span>
                </div>
                <ul className="woods-amenities-grid">
                  {outdoorAmenities.map((item) => {
                    const Icon = item.icon;
                    return (
                      <li className="woods-amenity-item" key={item.label}>
                        <span className="woods-amenity-box" aria-hidden="true">
                          <Icon size={13} />
                        </span>
                        <span className="woods-amenity-text">{item.label}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
